import _ from 'lodash';
//From: http://stackoverflow.com/questions/32574008/how-to-drag-text-file-into-text-area-to-show-contents-using-angular/32575592
angular
    .module("skillBuilderSaaS")
    .directive("sbFileDropZone", function () {
    return {
        restrict: "EA",
        scope: {
            content: "=",
            onDrop: "&"
        },
        link: function (scope, element, attrs) {
            var processDragOverOrEnter = function (event) {
                if (event) {
                    event.preventDefault();
                }
                event.dataTransfer = event.originalEvent.dataTransfer;
                if (event.dataTransfer.effectAllowed)
                    event.dataTransfer.effectAllowed = "copy";
                else //IE
                    event.dataTransfer.dropEffect = "copy";
                return false;
            };
            element.bind("dragover", processDragOverOrEnter);
            element.bind("dragenter", processDragOverOrEnter);
            element.bind("drop", handleDropEvent);
            function handleDropEvent(event) {
                //clear the textarea content (data and errors)
                scope.content.data = "";
                scope.content.error = "";
                scope.$apply();
                if (event) {
                    event.preventDefault();
                }
                event.dataTransfer = event.originalEvent.dataTransfer;
                //Set textarea error if user drags more than the max files
                if (event.dataTransfer.files.length > 1) {
                    scope.content.error = "common.fileDropZone.error.maxFiles";
                    scope.$apply();
                    return;
                }
                //Set textarea error if user drags a non-supported files
                var supportedFiles = _.map(attrs.supportedFileExtentions.split(","), function (item) {
                    return item.trim().substring(1);
                });
                var file = event.dataTransfer.files[0];
                if (!_.includes(supportedFiles, file.name.split(".").pop())) {
                    scope.content.error = "common.fileDropZone.error.notSupported";
                    scope.$apply();
                    return;
                }
                //All is good, set the textarea content to the dragged file content
                var reader = new FileReader();
                reader.onload = function insertText(loadedFile) {
                    if (!loadedFile.target.result) {
                        scope.content.error = "common.fileDropZone.error.fileEmpty";
                        scope.$apply();
                        return;
                    }
                    scope.content.data = loadedFile.target.result;
                    scope.$apply();
                    if (scope.onDrop) {
                        scope.onDrop();
                        scope.$apply();
                    }
                };
                reader.readAsText(file);
            }
        }
    };
});
